import {
  apiUserChangePassword,
  apiUserForgetPassword,
  apiUserGetJWT,
  apiUserGetMe,
  apiUserGoogleAuth,
  apiUserRegister,
} from "@/api/auth";
import {
  apiUserDeleteAccountsPayable,
  apiUserGetAccountsPayable,
  apiUserGetAccountsPayables,
  apiUserPostAccountsPayable,
  apiUserPutAccountsPayables,
} from "@/api/accountPayable";
import {
  apiUserDeleteAccountsPayablesDetail,
  apiUserGetAccountsPayablesDetail,
  apiUserGetAccountsPayablesDetails,
  apiUserPostAccountsPayablesDetail,
  apiUserPutAccountsPayablesDetails,
} from "@/api/accountPayableDetail";
import {
  apiUserDeleteAccountsProject,
  apiUserGetAccountsProject,
  apiUserGetAccountsProjects,
  apiUserPostAccountsProject,
  apiUserPutAccountsProjects,
} from "@/api/project";
import {
  apiUserDeleteAccountsProjectNode,
  apiUserGetAccountsProjectNode,
  apiUserGetAccountsProjectNodes,
  apiUserPostAccountsProjectNode,
  apiUserPutAccountsProjectNodes,
} from "@/api/projectNode";
import {
  apiUserDeleteAccountsReceivable,
  apiUserGetAccountsReceivable,
  apiUserGetAccountsReceivables,
  apiUserPostAccountsReceivable,
  apiUserPutAccountsReceivables,
} from "@/api/accountReceivable";
import {
  apiUserDeleteAccountsReceivablesDetail,
  apiUserGetAccountsReceivablesDetail,
  apiUserGetAccountsReceivablesDetails,
  apiUserPostAccountsReceivablesDetail,
  apiUserPutAccountsReceivablesDetails,
} from "@/api/accountReceivableDetail";
import {
  apiUserDeleteDepartment,
  apiUserGetDepartment,
  apiUserGetDepartments,
  apiUserPostDepartment,
  apiUserPutDepartment,
} from "@/api/department";
import {
  apiUserDeleteDesignBOM,
  apiUserGetDesignBOM,
  apiUserGetDesignBOMs,
  apiUserPostDesignBOM,
  apiUserPutDesignBOM,
} from "@/api/designBOM";
import {
  apiUserDeleteMaterialBOM,
  apiUserGetMaterialBOM,
  apiUserGetMaterialBOMs,
  apiUserPostMaterialBOM,
  apiUserPutMaterialBOM,
} from "@/api/materialBOM";
import {
  apiUserDeleteProductInventory,
  apiUserGetProductInventory,
  apiUserGetProductsInventory,
  apiUserPostProductInventory,
  apiUserPutProductsInventory,
} from "@/api/productInventory";
import {
  apiUserDeletePurchaseOrder,
  apiUserGetPurchaseOrder,
  apiUserGetPurchaseOrders,
  apiUserPostPurchaseOrder,
  apiUserPutPurchaseOrder,
} from "@/api/purchaseOrder";
import {
  apiUserDeletePurchaseOrderProduct,
  apiUserGetPurchaseOrderProduct,
  apiUserGetPurchaseOrderProducts,
  apiUserPostPurchaseOrderProduct,
  apiUserPutPurchaseOrderProduct,
} from "@/api/purchaseOrderProduct";
import {
  apiUserDeleteScanHistory,
  apiUserGetScanHistories,
  apiUserGetScanHistory,
  apiUserPostScanHistory,
  apiUserPutScanHistory,
} from "@/api/scanHistories";
import {
  apiUserDeleteSteelBolt,
  apiUserGetSteelBolt,
  apiUserGetSteelBolts,
  apiUserPostSteelBolt,
  apiUserPutSteelBolt,
} from "@/api/steelBolts";
import {
  apiUserDeleteStockReceiptProducts,
  apiUserGetStockReceiptProduct,
  apiUserGetStockReceiptProducts,
  apiUserPostStockReceiptProduct,
  apiUserPutStockReceiptProducts,
} from "@/api/stockReceiptProducts";
import {
  apiUserDeleteStockRequestProducts,
  apiUserGetStockRequestProduct,
  apiUserGetStockRequestProducts,
  apiUserPostStockRequestProduct,
  apiUserPutStockRequestProducts,
} from "@/api/stockRequestProducts";
import {
  apiUserDeleteStockRequests,
  apiUserGetStockRequest,
  apiUserGetStockRequests,
  apiUserPostStockRequest,
  apiUserPutStockRequests,
} from "@/api/stockRequest";
import {
  apiUserDeleteStorageLocations,
  apiUserGetStorageLocation,
  apiUserGetStorageLocations,
  apiUserPostStorageLocation,
  apiUserPutStorageLocations,
} from "@/api/storageLocation";
import {
  apiUserDeleteWorkItem,
  apiUserGetWorkItem,
  apiUserGetWorkItems,
  apiUserPostWorkItem,
  apiUserPutWorkItems,
} from "@/api/workItem";
import {
  apiUserGetCompanies,
  apiUserGetCompany,
  apiUserPostCompany,
} from "@/api/company";
import {
  apiUserGetEmployee,
  apiUserGetEmployees,
  apiUserGetAllEmployeesForUser,
  apiUserPostEmployee,
  apiUserPutEmployees,
} from "@/api/employee";
import {
  apiUserGetPartner,
  apiUserGetPartners,
  apiUserPostPartner,
  apiUserPutPartners,
} from "@/api/partner";
import {
  apiUserGetProduct,
  apiUserGetProducts,
  apiUserPostProduct,
  apiUserPutProducts,
} from "@/api/product";
import {
  apiUserGetStockReceipt,
  apiUserGetStockReceipts,
  apiUserPostStockReceipt,
  apiUserPutStockReceipts,
} from "@/api/stockReceipt";
import {
  apiUserGetWarehouse,
  apiUserGetWarehouses,
  apiUserPostWarehouse,
  apiUserPutWarehouses,
} from "@/api/warehouse";

import { apiUserUpload } from "@/api/upload";
import axios from "axios";
import { recordFailedRequestId } from "@/lib/request-id";

const ApiImageClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 400000,
});

ApiImageClient.interceptors.request.use(
  (config) => {
    if (!config.skipAuth) {
      //暫時用固定token
      let token = localStorage.getItem("jwtToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  },
);

ApiImageClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    recordFailedRequestId(error.response?.headers?.["x-request-id"]);
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export {
  apiUserUpload,
  ApiImageClient,
  apiUserPostCompany,
  apiUserGetJWT,
  apiUserRegister,
  apiUserGoogleAuth,
  apiUserPutDepartment,
  apiUserForgetPassword,
  apiUserChangePassword,
  apiUserGetCompany,
  apiUserGetCompanies,
  apiUserGetDepartment,
  apiUserGetDepartments,
  apiUserGetPartners,
  apiUserPostStockReceipt,
  apiUserPutStockReceipts,
  apiUserGetStockReceipts,
  apiUserGetStockReceipt,
  apiUserPutEmployees,
  apiUserGetPartner,
  apiUserPostProductInventory,
  apiUserDeleteProductInventory,
  apiUserPutProductsInventory,
  apiUserGetProductsInventory,
  apiUserGetProductInventory,
  apiUserDeleteDepartment,
  apiUserPostPartner,
  apiUserPostEmployee,
  apiUserGetMe,
  apiUserGetEmployee,
  apiUserGetEmployees,
  apiUserGetAllEmployeesForUser,
  apiUserPostDepartment,
  apiUserPutPartners,
  apiUserGetWarehouse,
  apiUserGetWarehouses,
  apiUserPostWarehouse,
  apiUserPutWarehouses,
  apiUserGetProduct,
  apiUserGetProducts,
  apiUserPostProduct,
  apiUserPutProducts,
  apiUserGetStorageLocation,
  apiUserGetStorageLocations,
  apiUserPostStorageLocation,
  apiUserPutStorageLocations,
  apiUserDeleteStorageLocations,
  apiUserGetStockReceiptProduct,
  apiUserGetStockReceiptProducts,
  apiUserPostAccountsPayablesDetail,
  apiUserPutAccountsPayablesDetails,
  apiUserGetAccountsPayablesDetails,
  apiUserGetAccountsPayablesDetail,
  apiUserDeleteAccountsPayablesDetail,
  apiUserPostStockReceiptProduct,
  apiUserDeleteStockReceiptProducts,
  apiUserPutStockReceiptProducts,
  apiUserPostStockRequest,
  apiUserPutStockRequests,
  apiUserGetStockRequests,
  apiUserGetStockRequest,
  apiUserDeleteStockRequests,
  apiUserPostStockRequestProduct,
  apiUserPutStockRequestProducts,
  apiUserGetStockRequestProducts,
  apiUserGetStockRequestProduct,
  apiUserDeleteStockRequestProducts,
  apiUserPostAccountsPayable,
  apiUserPutAccountsPayables,
  apiUserGetAccountsPayables,
  apiUserGetAccountsPayable,
  apiUserDeleteAccountsPayable,
  apiUserDeletePurchaseOrder,
  apiUserGetPurchaseOrder,
  apiUserGetPurchaseOrders,
  apiUserPostPurchaseOrder,
  apiUserPutPurchaseOrder,
  apiUserPostAccountsReceivablesDetail,
  apiUserPutAccountsReceivablesDetails,
  apiUserGetAccountsReceivablesDetails,
  apiUserGetAccountsReceivablesDetail,
  apiUserDeleteAccountsReceivablesDetail,
  apiUserPostAccountsReceivable,
  apiUserPutAccountsReceivables,
  apiUserGetAccountsReceivables,
  apiUserGetAccountsReceivable,
  apiUserDeleteAccountsReceivable,
  apiUserPostAccountsProject,
  apiUserPutAccountsProjects,
  apiUserGetAccountsProjects,
  apiUserGetAccountsProject,
  apiUserDeleteAccountsProject,
  apiUserGetPurchaseOrderProduct,
  apiUserGetPurchaseOrderProducts,
  apiUserPutPurchaseOrderProduct,
  apiUserDeletePurchaseOrderProduct,
  apiUserPostPurchaseOrderProduct,
  apiUserPostAccountsProjectNode,
  apiUserPutAccountsProjectNodes,
  apiUserGetAccountsProjectNodes,
  apiUserGetAccountsProjectNode,
  apiUserDeleteAccountsProjectNode,
  apiUserGetDesignBOM,
  apiUserGetDesignBOMs,
  apiUserPutDesignBOM,
  apiUserDeleteDesignBOM,
  apiUserPostDesignBOM,
  apiUserGetMaterialBOM,
  apiUserGetMaterialBOMs,
  apiUserPutMaterialBOM,
  apiUserDeleteMaterialBOM,
  apiUserPostMaterialBOM,
  apiUserGetSteelBolt,
  apiUserGetSteelBolts,
  apiUserPutSteelBolt,
  apiUserDeleteSteelBolt,
  apiUserPostSteelBolt,
  apiUserPostWorkItem,
  apiUserPutWorkItems,
  apiUserGetWorkItems,
  apiUserGetWorkItem,
  apiUserDeleteWorkItem,
  apiUserGetScanHistory,
  apiUserGetScanHistories,
  apiUserPostScanHistory,
  apiUserPutScanHistory,
  apiUserDeleteScanHistory,
};

export async function apiUserRemoveSteelAssemblyList({
  data,
}: {
  data: {
    documentId: string;
    steelAssemblyList: string[];
  };
}) {
  try {
    const result = await ApiImageClient.post(
      "/custom/project-node/removeSteelAssemblyList",
      { data },
    );
    return result.data;
  } catch (e) {
    console.error("apiUserRemoveSteelAssemblyList_Error", e);
    return e;
  }
}

export async function apiUserAddSteelAssemblyList({
  data,
}: {
  data: {
    documentId: string;
    steelAssemblyList: string[];
  };
}) {
  try {
    const result = await ApiImageClient.post(
      "/custom/project-node/addSteelAssemblyList",
      { data },
    );
    return result.data;
  } catch (e) {
    console.error("apiUserAddSteelAssemblyList_Error", e);
    return e;
  }
}
